import { render, staticRenderFns } from "./holiday-sheet-list.vue?vue&type=template&id=10b5af82&scoped=true&"
import script from "./holiday-sheet-list.vue?vue&type=script&lang=js&"
export * from "./holiday-sheet-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b5af82",
  null
  
)

export default component.exports